import { c as _c } from "react/compiler-runtime";
import { ViewTransition } from "react";

//#region [Props]
type SelectedDateTransitionProps = {
  isSelected?: boolean | null;
  children: React.ReactElement;
};
//#endregion

//#region [Component]
/**
 * Gives the selected date button's content a shared view transition name. When the selection changes in a Transition,
 * the old button's content unmounts from it and the new one's mounts, so the browser slides the highlight between them.
 * Only one date row is on a page at a time, so the name is unique.
 * Only the slide animates (default="none"): appearing, disappearing and updating don't.
 */
export default function SelectedDateTransition(t0) {
  const $ = _c(2);
  const {
    isSelected,
    children
  } = t0;
  if (!isSelected) {
    return children;
  }
  let t1;
  if ($[0] !== children) {
    t1 = <ViewTransition name="program-selected-date" share="auto" default="none">{children}</ViewTransition>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
//#endregion